module.exports = __webpack_public_path__ + "static/img/product_banner_33_zh.fbb0b21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_33_zh.png
// module id = V8Js
// module chunks = 34